var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"lf-btn bm-bordered-btn d-flex justify-content-center color-select-btn p-11",class:[_vm.selectedButton?'active':'inactive'],on:{"click":function($event){$event.stopPropagation();return _vm.switchActive.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }